(function ( $ ) {

    var neededScrollCount = 15; // amount of scrolls needed to achieve to jump into rechecking of header's appearance state
    var scrolledCounter = 0; //initial value for scrolledCounter - to show header initially (after page load)
    var currentScrollDir = 'FORWARD';

    $(document).on('ready', function () {

        var header = document.getElementsByClassName('header')[0];
        var isResponsive = $('#is-responsive').filter(':visible').length > 0;

        if ($('body').hasClass('custom-scroll')) {
            $pinnedSections = $('.pinned-section:visible');
            $pinnedSections.last().addClass('last-block');
        }

        if ( isResponsive ) {
            // always show header on mobile devices
            header.classList.add('header--visible');
        }

        if ( typeof ScrollMagic !== 'undefined' && !isResponsive ) { // on all devices except mobiles

            var headerCheckController = new ScrollMagic.Controller();

            var headerCheckScene = new ScrollMagic.Scene({
                triggerElement: header, duration: 0, triggerHook: 0
            }).addTo(headerCheckController);

            headerCheckScene.on('update', function () {

                // "PAUSED" is initial value for scrollDirection in ScrollMagic.js
                if ( currentScrollDir !== headerCheckController.info("scrollDirection") && "PAUSED" !== headerCheckController.info("scrollDirection") ) {
                    // resetting scrolledCounter if scrollDirection was changed and saving new scrollDir into currentScrollDir variable
                    currentScrollDir = headerCheckController.info("scrollDirection");
                    scrolledCounter = 0;
                }

                // console.log(scrolledCounter);

                if ( scrolledCounter++ > neededScrollCount ) {

                    // jumping into checking whether to show/hide header only if we scroll for a while in some particular direction
                    // (to prevent messy header appearing/disappearing)
                    scrolledCounter = 0;

                    (!header.classList.contains('menu-expanded') && (headerCheckController.info("scrollDirection") === "FORWARD" )) // scrollDirection can have "FORWARD" or "REVERSE" string value
                        ? header.classList.remove('header--visible') : header.classList.add('header--visible');
                }
            });
        }

        // every block that has Hash ACF field set up - should have [data-anchor] attribute, anchor link will be working by searching target block by value of this attribute
        scrollToAnchoredElement();

        $(window).on('hashchange', scrollToAnchoredElement);

        $('.off-canvas-content a[href*="#"]').on('click', scrollToAnchoredElement);

        function scrollToAnchoredElement() {
            var hash = window.location.hash;
            if ( hash !== '' && hash.indexOf('#') === 0 ) {
                var $targetBlock = $('[data-anchor="' + hash.replace('#', '') + '"]');
                if ( $targetBlock.length > 0 ) {
                    $([document.documentElement, document.body]).delay(100).animate({
                        scrollTop: $targetBlock.offset().top - 100
                    }, 500);
                }
            }
        }
    });

})( jQuery )